import { FEELING_ICONS } from '@iheartjane/menu';
import {
  CbdIcon,
  EdibleIcon,
  ExtractIcon,
  FlowerIcon,
  GearIcon,
  HybridIcon,
  IndicaIcon,
  MerchIcon,
  PrerollIcon,
  SativaIcon,
  TagIcon,
  TinctureIcon,
  TopicalIcon,
  VapeIcon,
} from '@iheartjane/reefer';
import type { ReactElement } from 'react';

export const renderFeelingIcon = (feeling: string) => {
  const Icon = FEELING_ICONS[feeling];
  return Icon ? <Icon color={null} /> : undefined;
};

const OTHER_FILTER_ICONS: Record<string, ReactElement> = {
  cbd: <CbdIcon color={null} />,
  edible: <EdibleIcon color={null} />,
  extract: <ExtractIcon color={null} />,
  flower: <FlowerIcon color={null} />,
  gear: <GearIcon color={null} />,
  hybrid: <HybridIcon color={null} />,
  indica: <IndicaIcon color={null} />,
  merch: <MerchIcon color={null} />,
  'pre-roll': <PrerollIcon color={null} />,
  sale: <TagIcon color="info" />,
  sativa: <SativaIcon color={null} />,
  tincture: <TinctureIcon color={null} />,
  topical: <TopicalIcon color={null} />,
  vape: <VapeIcon color={null} />,
};

export const renderFilterIcon = (value: string) =>
  renderFeelingIcon(value) ?? OTHER_FILTER_ICONS[value];
